// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1x0cl","header":"ReportDetails_header__24WaG","title":"ReportDetails_title__3Jphp","left":"ReportDetails_left__2yOUO"};